import React from "react";
import { formatTime } from "../../../../shared/dateTimeUtils";
import { minuteFormat } from "../../ObSummaryStore";
export default function AnnotationPopover({
  selectedAnnotation,
  timeToPosition,
  annotations,
}) {
  if (!selectedAnnotation) return null;
  const left = timeToPosition({
    time: selectedAnnotation.dateTime,
    relative: true,
  });
  const style = {};
  style.left = `${left * 100}%`;
  const minute = selectedAnnotation.dateTime.toFormat(minuteFormat);
  const selectedAnnotations = selectedAnnotation.isOverlapping
    ? annotations.filter((a) => a.dateTime.toFormat(minuteFormat) === minute)
    : [selectedAnnotation];

  return (
    <React.Fragment>
      <div className="selected-annotation" style={style}>
        {selectedAnnotations.map((annotation) => (
          <div key={annotation.annotationId}>
            {formatTime(annotation.dateTime)} -{" "}
            {annotation.annotation.slice(0, 500)}
          </div>
        ))}
      </div>
      <div className="pointer" style={style}></div>
    </React.Fragment>
  );
}
